export default __webpack_public_path__ + "static/media/banner-guarantees-limit-value.04757223.svg";